@for (review of reviews; track review) {
  <div class="review">
    @if (review.imageFileName) {
      <div class="profile">
        <div
          [style.background-image]="getImageUrl(review.imageFileName)"
          class="image"
          alt=""
        ></div>
      </div>
    }
    <div>
      <p class="body">
        <span class="quote-before">&ldquo;</span>{{ review.body
        }}<span class="quote-after">&rdquo;</span>
      </p>

      <p class="name">{{ review.name }}</p>
      <p class="title">{{ review.title }}</p>
    </div>
  </div>
}
